import { createStore } from 'vuex';
import { auth } from './auth.module';
import { playlist } from './PlayListStore';

const store = createStore({
  modules: {
    auth,
    playlist,
  },
});

export default store;
